/**
 * 순서대로 인터셉터 스텝이 실행된다.
 * 순서 잘 지키길
 *  */
const arr = [
  require('./tokenSignin'),
  require('./utm'),
  require('./auth'),
  require('./redirect'),
  require('./storeBusinessRedirect'),
  require('./popState'),
  require('./meta'),
  require('./uiReset'),
]

export default arr
